import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appValidCompanyName]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidCompanyNameDirective, multi: true }],
  standalone: false
})
export class ValidCompanyNameDirective implements Validator {
  static validator(control: AbstractControl): ValidationErrors | null {
    return control.value && typeof control.value === 'string' && ValidCompanyNameDirective.isForbiddenName(control.value) ? { appValidCompanyName: true } : null;
  }

  static isForbiddenName(name: string) {
    const forbiddenNames: RegExp[] = [
      /^termo\s/i, // começa com "termo "
      /^termos\s/i, // começa com "termos "
      /,/, // vírgula
      /\./, // ponto
      /:/, // dois pontos
      /autentique/i // palavra "autentique" em qualquer lugar
    ];

    const normalized = name.toLowerCase().trim().replace(/\s+/, ' ');
    return forbiddenNames.some(pattern => pattern.test(normalized));
  }

  constructor() {}

  validate(control: AbstractControl) {
    return ValidCompanyNameDirective.validator(control);
  }
}
